<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParam" :model="pageParam" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003466')" prop="price">
              <div class="flex align-items-center">
                <InputNumber :min="0" v-model="pageParam.priceStart" :formatter="value => `${parseInt(value)}`" style="width: 90px;"></InputNumber>
                <span class="ml12 mr12">-</span>
                <InputNumber v-model="pageParam.priceEnd" :formatter="value => `${parseInt(value)}`" style="width: 90px;"></InputNumber>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003467')" prop="totalEpScore">
              <Select v-model="pageParam.totalEpScore" transfer>
                <Option v-for="item in totalEpScoreList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003468')" prop="getRate24">
              <Select v-model="pageParam.getRate24" transfer>
                <Option v-for="item in getRate24List" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003469')" prop="getRate48H">
              <Select v-model="pageParam.getRate48H" transfer>
                <Option v-for="item in getRate48HList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="oneItemCol">
            <CheckboxGroup v-model="pageParam.typeList" class="flex align-items-center ml25 mt7">
              <Checkbox class="mr35" v-for="(item, index) in typesData" :key="index" :label="item.value">{{ item.title }}</Checkbox>
            </CheckboxGroup>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003470')" prop="keyword">
              <Input v-model.trim="pageParam.keyword" clearable></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search()" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <div class="flex align-items-center justify-content-end wid100P">
        <Button-group>
          <Button :type="item.checked ? 'primary' : 'default'" v-for="item in sortData" @click="clickSortButton(item)" :key="item.value">
            <span>{{ item.label }}</span>
            <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
            <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
          </Button>
        </Button-group>
      </div>
    </div>
    <!--列表区域-->
    <div class="findSimilarProducts_box" ref="scrollContainer" @scroll="handleScroll">
      <template v-if="tableList.length >0">
        <div class="findSimilarProducts_box_item" v-for="(item,index) in tableList" :key="index" @click="toAlibabaBtn(item)">
          <!--图片-->
          <div class="imageUrl_box">
            <img v-if="item.offerImage.imageUrl" :src="item.offerImage.imageUrl" alt="" :onerror="errorPlaceholder">
            <img v-else :src="failPlaceholder" alt=""/>
          </div>
          <!--金额-->
          <div class="price_box">
            <span class="font-size-17 font-weight-bold" style="color: #E80301;">{{ '￥ ' + item.offerPrice.price + $t('key1003471') }}</span>
            <div class="flex align-items-center font-size-12 color-333">
              <span>{{ $t('key1003474') }}</span>
              <span class="distributorThemeColor font-weight-bold">{{ item.historyTradeValue }}</span>
            </div>
          </div>
          <!--商品标题-->
          <div class="title_box ellipsis_2" :title="item.subject">{{ item.subject }}</div>
          <!--评分-->
          <div class="flex align-items-center justify-content-between mt5 pl12 pr12">
            <span>{{ item.quantityBegin + item.unit + $t('key1003472') }}</span>
            <span class="scoreStyle">{{ item.qualityEvaluation.compositeScore + $t('key1003473') }}</span>
          </div>
          <!--标签-->
          <div class="flex align-items-center flex-wrap pl12 pr12 mt8">
            <template v-if="item.serviceName.length >0">
              <span class="serviceNameStyle mr8 mb6" v-for="value in item.serviceName">{{ value }}</span>
            </template>
          </div>
        </div>
        <!--没有更多数据了-->
        <div class="noMoreData" v-if="tableList.length>=total">{{ $t('key1000677') }}</div>
      </template>
      <!--暂无数据-->
      <div v-else class="no_classify">
        <img :src="noContent" width="250" height="250" :alt="$t('key1000104')">
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {isValueEmpty} from "@/utils/common";

export default {
  name: "findSimilarProducts",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParam: {
        imageId: null,
        imageUrl: null,
        keyword: '',
        priceEnd: null,
        priceStart: null,
        totalEpScore: 'null', // 综合评分
        getRate24: 'null', // 24小时揽收率
        getRate48H: 'null', // 48小时揽收率
        typeList: [],
        upDown: 'asc',
        orderBy: 'price',
        pageNum: 1,
        pageSize: 20
      },
      total: 0,
      tableList: [],
      errorPlaceholder: "this.onerror='';this.classList.add('error-image'); this.src='" + require('@/assets/images/imageError.jpg') + "'",
      failPlaceholder: require('@/assets/images/imageFail.jpg'),
      noContent: require('@/assets/images/noDataIcon.png'),
      imageId: null,
      totalEpScoreList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003451'), value: 'null'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003452'), value: 'totalEpScoreLv1'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003453'), value: 'totalEpScoreLv2'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003454'), value: 'totalEpScoreLv3'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003455'), value: 'totalEpScoreLv4'},
      ],
      getRate24List: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003451'), value: 'null'},
        {title: '<95%', value: 'getRate24HLv1'},
        {title: '>=95%', value: 'getRate24HLv2'},
        {title: '>=99%', value: 'getRate24HLv3'}
      ],
      getRate48HList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003451'), value: 'null'},
        {title: '<95%', value: 'getRate48HLv1'},
        {title: '>=95%', value: 'getRate48HLv2'},
        {title: '>=99%', value: 'getRate48HLv3'}
      ],
      typesData: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003456'), value: 'certifiedFactory'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003457'), value: 'shipInToday'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003458'), value: 'shipIn24Hours'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003459'), value: 'shipIn48Hours'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003460'), value: 'noReason7DReturn'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003461'), value: 'isOnePsale'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003462'), value: 'isOnePsaleFreePost'}
      ],
      sortData: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003463'), value: 'price', checked: true, toogle: false},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003464'), value: 'monthSoldOut', checked: false, toogle: false}
      ],
    };
  },
  mounted() {
    this.$refs['scrollContainer'].addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    this.$refs['scrollContainer'].removeEventListener('scroll', this.handleScroll);
  },
  created() {
    this.pageParam.imageUrl = this.$route.query.imageUrl;
    let obj = JSON.parse(localStorage.getItem('findSimilarProductsFilterObj')) || '';
    if (obj) {
      for (let key in obj) {
        this.pageParam[key] = obj[key];
      }
      this.sortData.map((item) => {
        if (item.value === obj['orderBy']) {
          this.clickSortButton(item);
        }
      });
    } else {
      this.search();
    }
  },
  methods: {
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParam'].resetFields();
      v.pageParam.imageId = null;
      v.pageParam.priceStart = null;
      v.pageParam.priceEnd = null;
      v.imageId = null;
      v.pageParam.typeList = [];
      for (let key in v.pageParam) {
        if (['totalEpScore', 'getRate24', 'getRate48H'].includes(key)) {
          v.pageParam[key] = 'null';
        }
      }
      v.pageParam.upDown = 'asc';
      v.pageParam.orderBy = 'price';
      localStorage.removeItem('findSimilarProductsFilterObj');
      setTimeout(() => {
        v.search();
      }, 100);
    },
    // 查询按钮
    search() {
      this.tableList = [];
      this.pageParam.pageNum = 1;
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let {totalEpScore, getRate24, getRate48H, typeList, upDown, orderBy, ...obj} = v.pageParam;
      let cacheParameters = {totalEpScore, getRate24, getRate48H, typeList, upDown, orderBy};
      localStorage.setItem('findSimilarProductsFilterObj', JSON.stringify(cacheParameters));
      let list = [];
      for (let key in v.pageParam) {
        if (['totalEpScore', 'getRate24', 'getRate48H'].includes(key)) {
          if (v.pageParam[key] !== 'null') {
            list.push(v.pageParam[key]);
          }
        }
      }
      if (typeList.length > 0) {
        list.push(...typeList);
      }
      obj.filter = list.length > 0 ? list.join(',') : '';
      obj.sort = JSON.stringify({[orderBy]: upDown});
      return obj;
    },

    // 列表查询的方法
    getList() {
      let v = this;
      if (!isValueEmpty(v.pageParam.priceStart) && !isValueEmpty(v.pageParam.priceEnd)) {
        if (v.pageParam.priceStart <= v.pageParam.priceEnd) {
          handleList();
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003465'));
          return false;
        }
      } else {
        handleList();
      }

      function handleList() {
        v.tableLoading = true;
        v.axios.post(api.post_ymsProductInfo_shopping_queryAlibabaTongkuan, v.handleParameter()).then(response => {
          v.tableLoading = false;
          let data = response.data.result;
          if (data) {
            if (data.code === 'SUCCESS') {
              v.imageId = data.imageId || null;
              v.total = data.pageInfo.totalRecords;
              let newList = data.result || [];
              if (newList.length > 0) {
                newList.map((item) => {
                  let offerHistoryTradeInfo = item.offerHistoryTradeInfo || [];
                  let offerTradeServiceInfo = item.offerTradeServiceInfo || [];
                  item.historyTradeValue = offerHistoryTradeInfo.length > 0 ? offerHistoryTradeInfo[0].historyTradeValue : 0;
                  if (offerTradeServiceInfo.length > 0) {
                    item.serviceName = offerTradeServiceInfo.map((ele) => {
                      return ele.serviceName;
                    });
                  } else {
                    item.serviceName = [];
                  }
                });
              }
              v.tableList = [...v.tableList, ...newList];
              v.$forceUpdate();
            }
          }
        });
      }
    },
    // 滚动到底部加载更多
    handleScroll() {
      const container = this.$refs.scrollContainer;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;

      // 判断是否滚动到距离底部50px，并且不在加载数据的状态
      if (this.tableList.length < this.total) {
        if ((scrollTop + clientHeight >= scrollHeight - 100) && !this.tableLoading) {
          this.pageParam.pageNum += 1;
          this.pageParam.imageId = this.imageId;
          this.getList();
        }
      }
    },
    // 跳转到1688平台
    toAlibabaBtn(item) {
      let href = `https://detail.1688.com/offer/${item.offerId}.html`;
      window.open(href, '_blank');
    },
    // 点击排序的按钮
    clickSortButton(data) {
      if (data.value === this.pageParam.orderBy) {
        data.toogle = !data.toogle;
      }
      if (data.toogle) {
        this.pageParam.upDown = 'desc';
      } else {
        this.pageParam.upDown = 'asc';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.pageParam.orderBy = data.value;
      this.search();
    },
  }
};
</script>

<style lang="less" scoped>
.findSimilarProducts_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-height: 700px;
  overflow-y: auto;

  .findSimilarProducts_box_item {
    flex: 1;
    max-width: 305px;
    min-height: 430px;
    border-radius: 5px;
    background-color: #fff;
    margin: 10px;
    box-sizing: border-box;
    text-align: center;
    padding-bottom: 10px;

    .imageUrl_box {
      padding-top: 10px;

      img {
        width: 300px;
        height: 300px;
        object-fit: cover;
        display: inline-block;
      }
    }

    .price_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: 'PingFangSC-Regular';
      margin-top: 5px;
      padding: 0 12px;
    }


    .title_box {
      color: #000;
      font-size: 14px;
      font-family: 'PingFangSC-Regular';
      margin-top: 5px;
      text-align: left;
      padding: 0 12px;
      font-weight: bold;
    }

    .serviceNameStyle {
      padding: 1px 7px;
      border: 1px solid #02A7F0;
      color: #02A7F0;
      font-size: 12px;
      border-radius: 5px;
    }

    .scoreStyle {
      color: #FF6600;
      font-size: 12px;
      font-family: 'PingFangSC-Regular';
      font-weight: bold;
    }

    &:hover {
      cursor: pointer;
      box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);
    }
  }

  .no_classify {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 100px;

    .txt {
      font-size: 15px;
      color: #666;
      margin-top: 15px;
    }
  }

  .noMoreData {
    color: #666;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    width: 100%;
  }
}
</style>